import React from 'react';
import { CircularProgress } from '@mui/material';
import './Loader.module.scss';

const MLLoader = ({ loaderColor = undefined, loaderSize = 40 }) => {
  return (
    <div className="flex flex-col flex-1 justify-center items-center">
      <CircularProgress size={loaderSize} style={{ color: loaderColor }} />
    </div>
  );
};

export default MLLoader;
